export const supportedLocales = ["id", "en"] as const;
export type Locale = (typeof supportedLocales)[number];
export const defaultLocale: Locale = "id";
